import { Component, Input, OnInit, Output, EventEmitter, ViewChild, ElementRef, OnChanges } from '@angular/core';
import { AnimationTriggerMetadata, animate, style, state, transition, trigger } from '@angular/animations';

import { TooltipComponent } from '@component/tooltip';
import { ProfileWidgetState } from './profile-widget-state.enum';
import { WidgetService } from './profile-widget.service';

const triggerData1: AnimationTriggerMetadata = trigger('minimize', [
  state('1', style({ height: 0, opacity: 0 })),
  state('0', style({ height: '*', opacity: 1 })),
  transition('* => *', animate('300ms ease-in-out'))
]);

@Component({
  selector: 'pl-profile-widget',
  templateUrl: './profile-widget.component.html',
  styleUrls: ['./profile-widget.component.scss'],
  providers: [WidgetService],
  animations: [triggerData1]
})
export class ProfileWidgetComponent implements OnInit, OnChanges {
  @Input() heading: string;
  @Input() editMode: boolean;
  @Input() disableSaveBtn = false;

  @Output() editModeChanged = new EventEmitter();
  @Output() stateChanged = new EventEmitter();
  @Output() widgetSave = new EventEmitter();
  @Output() widgetCancel = new EventEmitter();

  @ViewChild('actionMenu') public actionMenu: ElementRef;
  @ViewChild('actionMenuTooltip', { static: true }) public actionMenuTooltip: TooltipComponent;

  public actionsForMenu;

  public state = ProfileWidgetState.MENU;
  public widgetActionMenu: any;

  constructor(private _widgetService: WidgetService) {}

  public ngOnInit() {
    this.setUpButtonFunctionality();
  }

  public toggle(action) {
    if (action.type === 'toggle') {
      action.activeAction = action.activeAction === 0 ? 1 : 0;
    }
  }

  public ngOnChanges(changes) {
    if (changes.editMode && changes.editMode.currentValue !== changes.editMode.previousValue) {
      changes.editMode.currentValue ? this.edit() : this.changeState(ProfileWidgetState.MENU);
    }
  }

  public setUpButtonFunctionality = () => {
    this.actionsForMenu = [
      { icon: 'mode_edit', name: 'Edit', action: () => this.edit() },
      { icon: 'vertical_align_center', name: 'Minimize', action: () => this.changeState(ProfileWidgetState.MINIMIZE) }
    ];
  };

  public selectAction(fn: () => void) {
    this.actionMenuTooltip.close();
    fn();
  }

  public openMenu() {
    this.widgetActionMenu.targetElement = this.actionMenu.nativeElement.getBoundingClientRect();
    this.actionMenuTooltip.open();
  }

  public edit(): any {
    this.editModeChanged.emit(true);
    this._widgetService.editAction = WidgetService.actions.EDIT;
    this.changeState(ProfileWidgetState.EDIT);
  }

  public save(): any {
    this.editModeChanged.emit(false);
    this._widgetService.editAction = WidgetService.actions.SAVE;
    this.widgetSave.emit(true);
    this.changeState(ProfileWidgetState.MENU);
  }

  public cancel(): any {
    this.editModeChanged.emit(false);
    this._widgetService.editAction = WidgetService.actions.CANCEL;
    this.widgetCancel.emit(true);
    this.changeState(ProfileWidgetState.MENU);
  }

  public changeState(latestState): any {
    this.state = latestState;
    this.stateChanged.emit(this.state);
    if (this.actionMenuTooltip) {
      this.actionMenuTooltip.close();
    }
  }

  public isEditMode() {
    return this.state === ProfileWidgetState.EDIT;
  }

  public checkState(latestState) {
    return this.state === latestState;
  }
}
